import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { FaEnvelope, FaArrowLeft, FaCheckCircle, FaSpinner } from 'react-icons/fa';

export default function ForgotPassword() {
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState({ type: '', text: '' });
    const [loading, setLoading] = useState(false);
    const { forgotPassword } = useAuth();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            setLoading(true);
            setStatus({ type: '', text: '' });
            const response = await forgotPassword(email);
            setStatus({ type: 'success', text: response.message || 'Reset link sent!' });
        } catch (err) {
            setStatus({ type: 'error', text: err.message || 'Something went wrong' });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen relative flex items-center justify-center overflow-hidden bg-blue-50">
            {/* Background Decorations */}
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-200 via-blue-100 to-white"></div>

            <div className="relative w-full max-w-md p-8 bg-white/60 backdrop-blur-2xl rounded-3xl shadow-xl border border-white/50 m-4">
                <Link to="/login" className="inline-flex items-center gap-2 text-sm font-bold text-gray-500 hover:text-gray-900 mb-8 transition-colors">
                    <FaArrowLeft /> Back to Login
                </Link>

                <div className="text-center mb-8">
                    <h2 className="text-2xl font-bold text-gray-900">Forgot Password?</h2>
                    <p className="mt-2 text-sm text-gray-500 font-medium">
                        No worries! Enter your email and we'll send you reset instructions.
                    </p>
                </div>

                {status.text && (
                    <div className={`mb-6 p-4 rounded-2xl flex items-start gap-3 ${status.type === 'success' ? 'bg-green-50 text-green-700' : 'bg-red-50 text-red-700'}`}>
                        {status.type === 'success' && <FaCheckCircle className="mt-1" />}
                        <p className="text-sm font-medium">{status.text}</p>
                    </div>
                )}

                {!status.type || status.type === 'error' ? (
                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="relative group">
                            <div className="absolute inset-y-0 left-0 pl-4 flex items-center pointer-events-none">
                                <FaEnvelope className="h-4 w-4 text-gray-400 group-focus-within:text-gray-600 transition-colors" />
                            </div>
                            <input
                                type="email"
                                required
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                className="block w-full pl-11 pr-4 py-3.5 bg-gray-50/50 border border-transparent rounded-2xl text-sm font-medium text-gray-900 focus:outline-none focus:bg-white focus:ring-4 focus:ring-gray-100/50 focus:border-gray-200 transition-all duration-200"
                                placeholder="Enter your email"
                            />
                        </div>

                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full h-12 flex items-center justify-center bg-gray-900 hover:bg-gray-800 text-white rounded-2xl font-bold transition-all duration-200 shadow-lg"
                        >
                            {loading ? <FaSpinner className="animate-spin h-5 w-5" /> : 'Send Reset Link'}
                        </button>
                    </form>
                ) : (
                    <div className="text-center py-4">
                        <p className="text-sm text-gray-500 mb-6 font-medium">
                            Didn't receive the email? Check your spam folder or try again.
                        </p>
                        <button
                            onClick={() => setStatus({ type: '', text: '' })}
                            className="text-gray-900 font-bold hover:underline text-sm"
                        >
                            Try another email
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}
